"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeDateSelection = void 0;
var _react = require("react");
var _EnvironmentManager = require("../../EnvironmentManager.provider");
var _main = require("../../../../main");
var _EnvironmentManager2 = _interopRequireDefault(require("../../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var RangeDateSelection = function RangeDateSelection(props) {
  var _ref, _ref2, _ref3, _ref4;
  var minDate = props.minDate,
    maxDate = props.maxDate,
    startDate = props.startDate,
    endDate = props.endDate,
    isDisabled = props.isDisabled,
    _onChange = props.onChange;
  var _useContext = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext),
    getLabel = _useContext.getLabel;
  var styles = (0, _EnvironmentManager2.default)();
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDates = _useState2[0],
    setSelectedDates = _useState2[1];
  (0, _react.useEffect)(function () {
    if (startDate && endDate) {
      setSelectedDates([startDate, endDate]);
    }
  }, [startDate, endDate]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManager_Dates'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.RangeDatePicker, {
      view: "menu",
      anchorSubTextStart: getLabel('schedule_start_text'),
      startDate: (_ref = selectedDates && selectedDates[0]) !== null && _ref !== void 0 ? _ref : undefined,
      endDate: (_ref2 = selectedDates && selectedDates[1]) !== null && _ref2 !== void 0 ? _ref2 : undefined,
      minDate: minDate,
      maxDate: maxDate,
      attachedTo: 'StartDate',
      isDisabled: isDisabled,
      onChange: function onChange(startDateTime, endDateTime) {
        if (startDateTime && selectedDates !== null && selectedDates !== void 0 && selectedDates[1] && startDateTime > selectedDates[1]) {
          setSelectedDates([startDateTime, endDateTime !== null && endDateTime !== void 0 ? endDateTime : startDateTime]);
        } else {
          setSelectedDates([startDateTime, selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates[1]]);
        }
        if (startDateTime && endDateTime) {
          _onChange(startDateTime, endDateTime !== null && endDateTime !== void 0 ? endDateTime : startDateTime);
        }
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.RangeDatePicker, {
      view: "menu",
      anchorSubTextEnd: getLabel('schedule_end_text'),
      startDate: (_ref3 = selectedDates && selectedDates[0]) !== null && _ref3 !== void 0 ? _ref3 : undefined,
      endDate: (_ref4 = selectedDates && selectedDates[1]) !== null && _ref4 !== void 0 ? _ref4 : undefined,
      minDate: minDate,
      maxDate: maxDate,
      attachedTo: 'EndDate',
      isDisabled: isDisabled,
      onChange: function onChange(startDateTime, endDateTime) {
        if (endDateTime && selectedDates !== null && selectedDates !== void 0 && selectedDates[0] && endDateTime < selectedDates[0]) {
          setSelectedDates([startDateTime !== null && startDateTime !== void 0 ? startDateTime : endDateTime, endDateTime]);
        } else {
          setSelectedDates([selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates[0], endDateTime]);
        }
        if (startDateTime && endDateTime) {
          _onChange(startDateTime !== null && startDateTime !== void 0 ? startDateTime : endDateTime, endDateTime);
        }
      }
    })]
  });
};
exports.RangeDateSelection = RangeDateSelection;